import { Injectable, ErrorHandler, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorDialogComponent } from 'src/shared/utilities/error-dialog/error-dialog.component';
import { errorTypes } from 'src/shared/constants';
import { RailProsError } from 'src/shared/models/rail-pros-error.model';
import { Subject, Observable } from 'rxjs';
import { exhaustMap } from 'rxjs/operators';
import { ErrorsService } from './errors.service';

@Injectable({
	providedIn: 'root',
})
export class RailProsErrorHandlerService implements ErrorHandler {
	private readonly _dialogErrorMessage = new Subject<string>();
	private readonly _snackBarErrorMessage = new Subject<string>();

	constructor(
		private readonly zone: NgZone,
		private readonly snackBar: MatSnackBar,
		private readonly errorDialog: MatDialog,
		private readonly errorsService: ErrorsService
	) {
		this._dialogErrorMessage
			.pipe(exhaustMap((msg) => this.displayMessageInDialog(msg)))
			.subscribe();

		this._snackBarErrorMessage
			.pipe(exhaustMap((msg) => this.displayMessageInSnackBar(msg)))
			.subscribe(() => this.snackBar.dismiss());
	}

	handleError(error: any): void {
		if (
			error.status === errorTypes.FRIENDLY_MESSAGE_CODE &&
			error.response
		) {
			this.displayMessageInDialog(error.response).subscribe(() =>
				this.errorsService.notifyError()
			);
		} else if (error.response) {
			this._snackBarErrorMessage.next(error.response);
			// this.displayMessageInSnackBar(error.response);
		} else if (error instanceof RailProsError && error.friendlyMessage) {
			this._dialogErrorMessage.next(error.friendlyMessage);
		} else if (
			!/ExpressionChangedAfterItHasBeenCheckedError/.test(error.message)
		) {
			this._snackBarErrorMessage.next(
				'The operation did not complete, because an application error occurred.'
			);
		}

		// The default global error handling for Angular is to console.error the error. This error handler
		// isn't an extension of the default handling, but an override. So if we don't call this here,
		// nothing will ever get logged to the console.
		console.error(error);
	}

	private displayMessageInDialog(message: string): Observable<any> {
		return this.zone.run(() => {
			return this.errorDialog
				.open(ErrorDialogComponent, {
					data: message,
					width: '450px',
				})
				.afterClosed();
		});
	}

	private displayMessageInSnackBar(message: string): Observable<any> {
		return this.zone.run(() => {
			return this.snackBar.open(message, 'X').onAction();
		});
	}
}
